import { useMemo } from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

/** Markdown → HTML sanitizado (sem script, iframe, estilo ou handlers). Links externos abrem em nova aba. */
export function renderMarkdown(source: string): string {
  const html = marked.parse(source ?? '', { async: false, gfm: true, breaks: true }) as string;
  const clean = DOMPurify.sanitize(html, { USE_PROFILES: { html: true }, FORBID_TAGS: ['style', 'iframe', 'form', 'input'], FORBID_ATTR: ['style'] });
  return clean.replace(/<a href="(https?:\/\/[^"]+)"/g, '<a href="$1" target="_blank" rel="noopener noreferrer"');
}

/** Corpo de FAQ/tutorial da Central de Ajuda. */
export function Markdown({ source, className }: { source: string; className?: string }) {
  const html = useMemo(() => renderMarkdown(source), [source]);
  return <div className={`k-md ${className ?? ''}`} dangerouslySetInnerHTML={{ __html: html }} />;
}

/** Vídeo do YouTube em modo de privacidade reforçada (youtube-nocookie). */
export function YouTubeEmbed({ id, title }: { id: string; title?: string | null }) {
  return (
    <div className="k-video">
      <iframe src={`https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?rel=0`} title={title ?? 'YouTube'} loading="lazy" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
    </div>
  );
}
